// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyBdJqASQ8uKl6Uy2YQsSUAlJujTeUTwYjU",
    authDomain: "motion-ride-96ad1.firebaseapp.com",
    projectId: "motion-ride-96ad1",
    storageBucket: "motion-ride-96ad1.firebasestorage.app",
    messagingSenderId: "962682328119",
    appId: "1:962682328119:web:2cc7b869d1707cb738dbb2",
    // measurementId: "G-MGNLJ9KN89"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
